import React from "react"
import "./style.scss"

export function Outlook(props) {
  const { outlook, isAuthenticated, userAccess } = props
  const hasAccess = isAuthenticated && userAccess === "FULL"
  return (
    <article className="vendor-outlook">
      <h3 className="outlook-title">{outlook.title}</h3>
      <p className="outlook-text">
        {outlook.text}
        {!hasAccess && (
          <span data-isauthorized={false} data-cy="blurred-outlook">
            simply dummy text of the printing and typesetting industry.
          </span>
        )}
      </p>
    </article>
  )
}
